<template>
  <v-card class="pa-4">
    <v-card-title primary-title>
      <div>
        <div class="title text-center">Enroll in MFA</div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-card>
        <v-card-text>
          <p>
            Once you click OK below your login account will be tagged as Multi
            Factor Authentication as required.
          </p>
          <p>
            Note: If you have already done this, you can just safely ignore
            this, and hit cancel.
          </p>
          <p>
            The next time you log into this application you will be prompted
            with a screen like this - follow the instructions on screen to
            complete.
          </p>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-text>
      <center>
        <div class="text-center">
          <img src="@/assets/images/mfa_sample.png" height="400px" />
        </div>
      </center>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="loading" @click="onClickSubmit">
        {{ loading ? 'Loading' : 'Ok' }}
      </v-btn>
      <v-btn color="primary" :disabled="loading" @click="closeDialog">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`)
export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `auth/getField`,
  mutationType: `auth/updateField`,
})
export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapAuthFields(['token', 'userProfile']),
  },
  methods: {
    ...mapAuthActions(['addMFAToUser']),

    closeDialog() {
      this.$emit('closeDialog')
    },

    async onClickSubmit() {
      try {
        this.loading = true
        await this.addMFAToUser(this.userProfile.name)
        this.loading = false
        this.closeDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
